import { Component, HostListener, ViewChild } from '@angular/core';
import { Route, Router, RouterModule } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Logout } from '../../../../store/action/auth.action';
import { AuthState } from '../../../../store/state/auth.state';
import { Observable } from 'rxjs';
import { AccountState } from '../../../../store/state/account.state';
import { AccountUser } from '../../../../interface/account.interface';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '../../../widgets/modal/confirmation-modal/confirmation-modal.component';
import { AuthService } from '../../../../services/auth.service';
import { LoginModalComponent } from '../../../widgets/modal/login-modal/login-modal.component';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule,
    ConfirmationModalComponent, LoginModalComponent ],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent {

  public isLogin: boolean;
  
  @ViewChild("loginModal") LoginModal: LoginModalComponent;

  @Select(AccountState.user) user$: Observable<AccountUser>;
  @Select(AuthState.isAuthenticated) isAuthenticated$: Observable<Boolean>;
  mobileView: boolean = false;

  constructor(private authService: AuthService, private modal: NgbModal,
    public route: Router, private store: Store) {
      this.onResize();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if(window?.innerWidth <= 768){
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }    
  }

  ngOnInit(){
    this.isAuthenticated$.subscribe(res => {
      this.isLogin = Boolean(res)
    })
  }

  account(){
    this.authService.redirectUrl = '/account/dashboard';
    if(this.isLogin){
      this.route.navigate(['/account/dashboard'])
    } else {
      if (this.mobileView) {
        this.route.navigateByUrl('/auth');
      }else{
        this.authService.isLogin = true;
      }
    }
  }

  
  logout() {
     alert(this.authService.isLogin)
    if(!this.store.selectSnapshot(state => state.auth && state.auth.token)) {
      this.authService.isLogin = true;
    } else {
      const modalRef = this.modal.open(ConfirmationModalComponent, { centered: true });
      modalRef.result.then(
        (result) => {
          // Modal closed with a result (e.g., "Confirmed" button clicked)
          console.log('Modal closed with:', result);
        },
        (reason) => {
          // Modal dismissed (e.g., clicking outside or pressing ESC)
          console.log('Modal dismissed due to:', reason);
        }
      );
    }
    
  }
}
